/**
 * FAQ Page — Search, Filter & Category Navigation
 */
(function () {
  'use strict';

  const FAQ_SELECTORS = {
    search: '.faq-page__search-input',
    clear: '.faq-page__search-clear',
    categoryBtn: '.faq-page__category-btn',
    section: '.faq-page__section',
    item: '.faq-page__item',
    noResults: '.faq-page__no-results',
    questionText: '.faq-page__item-summary span:first-child',
    answerText: '.faq-page__item-content',
  };

  class FAQPage {
    constructor() {
      this.searchInput = document.querySelector(FAQ_SELECTORS.search);
      this.clearBtn = document.querySelector(FAQ_SELECTORS.clear);
      this.categoryBtns = document.querySelectorAll(FAQ_SELECTORS.categoryBtn);
      this.sections = document.querySelectorAll(FAQ_SELECTORS.section);
      this.items = document.querySelectorAll(FAQ_SELECTORS.item);
      this.noResults = document.querySelector(FAQ_SELECTORS.noResults);
      this.activeCategory = 'all';

      if (!this.searchInput) return;
      this.init();
    }

    init() {
      this.searchInput.addEventListener('input', this.handleSearch.bind(this));
      this.clearBtn?.addEventListener('click', this.clearSearch.bind(this));
      this.categoryBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleCategoryClick.bind(this));
      });
    }

    handleSearch() {
      const query = this.searchInput.value.trim().toLowerCase();
      this.toggleClearBtn(query.length > 0);

      if (query.length === 0) {
        this.resetSearch();
        return;
      }

      // Deactivate category filter during search
      this.categoryBtns.forEach((btn) => btn.classList.remove('is-active'));
      const allBtn = document.querySelector('[data-category="all"]');
      if (allBtn) allBtn.classList.add('is-active');
      this.activeCategory = 'all';

      let visibleCount = 0;

      this.items.forEach((item) => {
        const questionEl = item.querySelector(FAQ_SELECTORS.questionText);
        const answerEl = item.querySelector(FAQ_SELECTORS.answerText);
        const questionText = questionEl?.textContent?.toLowerCase() || '';
        const answerText = answerEl?.textContent?.toLowerCase() || '';

        if (questionText.includes(query) || answerText.includes(query)) {
          item.classList.remove('is-hidden');
          visibleCount++;
        } else {
          item.classList.add('is-hidden');
        }
      });

      // Show/hide sections based on whether they have visible items
      this.sections.forEach((section) => {
        const visibleItems = section.querySelectorAll(`${FAQ_SELECTORS.item}:not(.is-hidden)`);
        section.classList.toggle('is-hidden', visibleItems.length === 0);
      });

      // Show no results message
      this.noResults?.classList.toggle('is-visible', visibleCount === 0);
    }

    clearSearch() {
      this.searchInput.value = '';
      this.toggleClearBtn(false);
      this.resetSearch();
      this.searchInput.focus();
    }

    resetSearch() {
      this.items.forEach((item) => item.classList.remove('is-hidden'));
      this.sections.forEach((section) => section.classList.remove('is-hidden'));
      this.noResults?.classList.remove('is-visible');
      this.filterByCategory(this.activeCategory);
    }

    handleCategoryClick(e) {
      const btn = e.currentTarget;
      const category = btn.dataset.category;

      this.categoryBtns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      this.activeCategory = category;

      // Clear search when switching categories
      this.searchInput.value = '';
      this.toggleClearBtn(false);
      this.items.forEach((item) => item.classList.remove('is-hidden'));
      this.noResults?.classList.remove('is-visible');

      this.filterByCategory(category);
    }

    filterByCategory(category) {
      if (category === 'all') {
        this.sections.forEach((section) => section.classList.remove('is-hidden'));
      } else {
        this.sections.forEach((section) => {
          const sectionCategory = section.dataset.category;
          section.classList.toggle('is-hidden', sectionCategory !== category);
        });
      }
    }

    toggleClearBtn(visible) {
      this.clearBtn?.classList.toggle('is-visible', visible);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new FAQPage());
  } else {
    new FAQPage();
  }
})();
